import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function BaccaratRoomList() {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [dataRoom, setDataRom] = useState<any>([]);
  const Cookies = require("js-cookie");
  const navigate = useNavigate();
  const [coins, setCoins] = useState(0);

  const token = Cookies.get("access_token");
  const user_infor = localStorage.getItem("user_info");

  useEffect(() => {
    if (user_infor) {
      const test = JSON.parse(user_infor);
      setCoins(test.coins);
    }
  }, [user_infor]);

  const isShowText = (value: any) => {
    if (value.maintenance === 1) {
      return "Đang bảo trì";
    }
    if (value.percentCurrent.Forecast) {
      return Math.round(value.percentCurrent.Forecast) + "%";
    }
    if (value.shuffle !== 0) {
      return "Đang xáo bài";
    }
  };

  const handleClick = (value: any) => {
    if (coins !== 0) {
      navigate(`/casino/room/${value.tableName}`);
    } else {
      Swal.fire({
        icon: "error",
        title: "Lỗi tải dữ liệu",
        text: "Vui lòng nạp thêm xu vào tài khoản!",
        customClass: {
          popup: "bg-custom-image text-white",
        },
      });
    }
  };

  const RoomCard = ({ value }: any) => {
    return (
      <div className="w-1/2 md:w-1/3 lg:w-1/4 p-2">
        <div
          className="room-box bg-gray-800 rounded-xl p-4 shadow-lg"
          onClick={() => handleClick(value)}
        >
          <h2 className="text-white text-center text-xl font-bold">
            BÀN: <span className="room-number">{value.tableName}</span>
          </h2>
          <h2 className="percent-room text-center font-semibold text-white drop-shadow-[0_0_6px_#55abd3] text-[2rem]">
            {isShowText(value)}
          </h2>
          <p className="text-white text-center mt-3 mb-1">Tỷ lệ thắng</p>
        </div>
      </div>
    );
  };

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataRoom.length === 0) {
      setIsLoading(true);
      Swal.fire({
        title: "Đang tải dữ liệu trò chơi",
        html: "Load <b></b> Data.",
        timerProgressBar: true,
        customClass: {
          popup: "bg-custom-image text-white",
        },
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const timeout = setTimeout(() => {
        axios
          .get(
            `${process.env.REACT_APP_URL_API_CASINO}/predict/get-all-table`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((data) => setDataRom(data.data))
          .catch((err) => console.log(err));
      }, 1000); // Delay 1 giây

      return () => clearTimeout(timeout);
    } else {
      setIsLoading(false);
      Swal.close();
    }

    // Clear timeout nếu component bị unmount hoặc dependencies thay đổi
  }, [dataRoom]);

  return (
    <>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div
        className="min-h-screen bg-cover bg-center container-fluid lobby-bg position-relative  mx-auto    mb-5 max-w-screen-xl"
        style={{
          backgroundImage: "url(https://trumcasino6789.com/images/bg-game.jpg)",
        }}
      >
        <div className="container mx-auto py-10 px-4">
          <div className="flex flex-wrap justify-center items-center mb-6">
            <div className="w-1/2 md:w-2/3">
              <img
                src="https://trumcasino6789.com/images/logo_ae.png"
                alt="logo"
                className="h-25"
              />
            </div>

            <div className="w-1/2 md:w-1/3 flex justify-center items-center">
              <a
                href="/casino"
                className="text-white px-4 py-2 rounded-lg shadow box-goto-lobby w-[10rem]"
              >
                Quay lại
              </a>
            </div>
          </div>

          {!isLoading && (
            <div className="flex flex-wrap">
              {dataRoom.map((e: any) => (
                <RoomCard key={e.id} value={e} />
              ))}
            </div>
          )}
        </div>
        <ModalConfirmLogout
          isShowLogout={isShowLogout}
          setIsShowLogout={() => {
            setIsShowLogout(false);
          }}
        />
      </div>
    </>
  );
}
